import React from "react";
import { View, StyleSheet, Text, Platform } from "react-native";

import fontStyles from "../../../fonts";
import appStyles from "../../../appStyles";
import ManaButton from "../ManaButton";
import OperationIcon from "../ActionsMenuButton/icons/OperationIcon";
import { isWeb } from "../../../../helpers/utils";

export default function AutoTrackHeader({
  context,
  subTitle = "Schedule confirmed from integrations & predictions",
}) {
  const { toggleAutoTrackMode = () => {} } = context || {};

  return (
    <View style={{ backgroundColor: "#F6EC91", paddingTop: isWeb ? 20 : 40 }}>
      <View
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
        }}
      >
        <View style={{ marginLeft: 14, marginRight: 6 }}>
          <OperationIcon />
        </View>
        <View>
          <Text style={fontStyles.h5}>Autotrack Mode</Text>
          <Text style={fontStyles.subtitle}>{subTitle}</Text>
        </View>
      </View>

      <View
        style={[
          appStyles.horizontalButtons,
          { marginTop: 3, marginBottom: 5, paddingHorizontal: 16 },
        ]}
      >
        <ManaButton
          text={"Switch to Manual Mode"}
          style={styles.button}
          styleText={styles.buttonText}
          onPress={() => toggleAutoTrackMode(false)}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  button: {
    width: "100%",
    height: 30,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
  },
});
